import { getRequest } from '../../services/httpService';


export interface BirthDetail {
  sac_no: string;
  fetal_heart: boolean;
  outcome_type: string;
  outcome_type_label?: string;
  birth_weight: string;
  congenital_abnormality: string;
  activity: string;
  pulse: string;
  grimace: string;
  appearance: string;
  respiration: string;
  covid_positive: string;
  apgar_score: number;
  remarks: string;
}

export interface OutcomeDetail {
  embryo_transfer_date: string;
  bhcg: string;
  result: string;
  status: string;
}

export interface CycleOutcome {
  id: number;
  patient: number;
  birth_details: BirthDetail[];
  outcome_details: OutcomeDetail[];
  observation_date: string;
  no_of_sacs: number;
  remarks: string;
  complications: string;
  files: string[];
  cycle: number;
  cycle_number: string;
  created_on: string;
  updated_on: string;
  pregnancy_type: string;
  weeks_of_gestation: number;
  delivery_type: string;
  monochorionic_twins: string;
  cancel_cycle: boolean;
}

export interface Cycle {
  id: string;
  cycle_number: string;
  cycle_name: string;
  cycle_name_label?: string;
  status: string;
  lmp_date: string | null;
  medication_protocol: string | null;
  medication_protocol_label?: string | null;
  medication_protocol_name?: string | null;
  procedure: {
    indication: string | null;
    indication_label?: string | null;
    procedures: string | null;
    procedures_label?: string | null;
    donor_info: {
      sperm_source: Array<{
        first_name: string;
        last_name: string;
        medical_record_no: string;
        photo: string | null;
      }>;
      oocyte_source: Array<{
        first_name: string;
        last_name: string;
        medical_record_no: string;
        photo: string | null;
      }>;
    };
  };
  follicules: number | null;
  opu: string | null;
  opu_status:boolean | string |null;
  oocyte_count: number | null;
  oocyte_details: number | null;
  fertilized_count: number | null;
  outcome: CycleOutcome | null;
  cleaved_count: number | null;
  cryopreserved_count: number | null;
  total_embryooocyte_count: number | null;
  fresh_transfer_count: number | null;
  frozen_transfer_count: number | null;
  bhcg_upt: string | null;
  pregnancy_confirmation: string | null;
  remaining_embryos: number | null;
  remarks: string | null;
  cancel_reason: string | null;  
  cancel_reason_label?: string | null;
    optimum_follicles?: {
      left_follicles?:  number | null;
      right_follicles?: |number| null;
    }
opu_event?: object;
et_event?: object;
}

export interface CycleOverviewPermission {
  name: string;
  featureEnabled: boolean;
  type: Array<{
    name: string;
    featureEnabled: boolean;
    permissions: Array<{
      access: 'add' | 'edit' | 'view' | 'print';
      male: boolean;
      female: boolean;
    }>;
    male: boolean;
    female: boolean;
  }>;
}

export function getcycleListUrl(patientId: string): string {
  return `/cycle/patient/${patientId}/`; 
}

export function getcycleList(patientId: string, signal?: AbortSignal): Promise<Cycle[]> {
  return getRequest(getcycleListUrl(patientId), { responseType: 'json', signal });
}
